import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import {TranslateService} from '@ngx-translate/core';
import { NavigationItem } from 'src/app/core/types/navigation';
import { DefaultNavigation, DefaultConfiguration} from 'src/app/core/navigation/app-navigation'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() isCondensed = false;
  menu: any;
  defaultNavigationRoutes: NavigationItem[];
  defaultConfigurationRoutes: NavigationItem[];
  allowedPermissions:any[] = []

  @ViewChild('sideMenu', { static: false }) sideMenu: ElementRef;

  constructor(public translate: TranslateService,private appService:AppService) {
    this.translate.addLangs(['en', 'de']);
    if (localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
    } else {
      localStorage.setItem('locale', 'en');
      translate.setDefaultLang('en');
    }
    this.allowedPermissions = JSON.parse(localStorage.getItem('Permissions'))
   
     this.defaultNavigationRoutes = DefaultNavigation;
     
    // this.defaultConfigurationRoutes = DefaultConfiguration;
     this.setViewAccessRightsForNavs(this.defaultNavigationRoutes);
    // this.setViewAccessRightsForNavs(this.defaultConfigurationRoutes);

  }

  ngOnInit() {
    
    
  }
  setViewAccessRightsForNavs(defaultRoutes) {
    if (defaultRoutes)
      defaultRoutes.forEach(navI => {
        if (this.appService.checkpermission(navI.code)) {
          navI.visible = true;
        } else {
          navI.visible = false;
        }
        // if (navI.children.length > 0) {
        //   this.setViewAccessRightsForNavs(navI.children)
        // }
      })
  }
  getMenuAccess(PermissionCode, PermissionIndex) {
    if (!PermissionCode) return true;
    var accessRights = JSON.parse(localStorage.getItem("accessRights"));
    if (accessRights[PermissionCode] && accessRights[PermissionCode] != '' && accessRights[PermissionCode] != null) {
      var PermissionArray = accessRights[PermissionCode].split(",");
      if (PermissionArray[PermissionIndex] && PermissionArray[PermissionIndex] == 1) {
        return true;
      }
    }
    return false;
  }
  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);

    this._activateMenuDropdown();
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  /**
   * small sidebar
   */
  smallSidebar() {
    document.body.classList.add('left-side-menu-sm');
    document.body.classList.remove('left-side-menu-dark');
    document.body.classList.remove('topbar-light');
  }

  /**
   * Dark sidebar
   */
  darkSidebar() {
    document.body.classList.remove('left-side-menu-sm');
    document.body.classList.toggle('left-side-menu-dark');
  }

  /**
   * Light Topbar
   */
  lightTopbar() {
    document.body.classList.add('left-side-menu-dark');
    document.body.classList.add('topbar-light');
    document.body.classList.remove('left-side-menu-sm');
    document.body.classList.remove('enlarged');

  }

  /**
   * Sidebar collapsed
   */
  sidebarCollapsed() {
    document.body.classList.add('enlarged');
    document.body.classList.remove('left-side-menu-dark');
    document.body.classList.remove('left-side-menu-sm');
    document.body.classList.remove('boxed-layout');

  }

  /**
   * Boxed Layout
   */
  boxedLayout() {
    document.body.classList.toggle('boxed-layout');
    document.body.classList.remove('left-side-menu-dark');
    document.body.classList.add('enlarged');
  }

  /**
   * Activates the menu dropdown
   */
  _activateMenuDropdown() {
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (window.location.pathname === links[i]['pathname']) {
        menuItemEl = links[i];
        break;
      }
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');

      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('active');

        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.add('in');
        }

        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.add('active');
          parent3El.firstChild.classList.add('active');
        }
      }
    }
  }

}
